const escapeFilterString = filterString => {
  // Replace all singlequotes to double singlequotes because
  // viya services treat double singlequotes as single singlequotes
  return filterString.replace(/'/g, "''");
};
export const getFilterExpression = function getFilterExpression(filterOperator, filterKey) {
  const escapedFilterKey = escapeFilterString(filterKey);
  for (var _len = arguments.length, filterValues = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    filterValues[_key - 2] = arguments[_key];
  }
  const escapedFilterValues = filterValues.map(filterValue => escapeFilterString(filterValue)).join("','");
  return `${filterOperator}(${encodeURIComponent(`${escapedFilterKey},'${escapedFilterValues}'`).replace(/['()]/g, escape)})`;
};
export const getLogicalExpression = (operator, firstOperand, secondOperand) => {
  if (!firstOperand) return secondOperand;
  if (!secondOperand) return firstOperand;
  return `${operator}(${firstOperand}${encodeURIComponent(',')}${secondOperand})`;
};
export const MAX_LIMIT = Math.pow(2, 15) - 1;
//# sourceMappingURL=utils.js.map